import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, ViewChild, inject } from "@angular/core";
import { FormsModule, NgForm, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { LayoutAlignDirective, LayoutDirective, FlexFillDirective } from "@ngbracket/ngx-layout/flex";
import { Command, CommandBarComponent, LabelCommand } from "@tylertech/commands-module";
import { ApiService } from "@tylertech/core-module";
import { ForgeLinearProgressModule } from "@tylertech/forge-angular";
import { Utilities } from "@tylertech/shared-module";
import { ClassMetadata } from "@tylertech/tyler-api-types";
import { MetadataService } from "../../services/metadata.service";
import { MetadataPanelComponent } from "../metadataPanel/metadataPanel.component";

export interface MetadataDialogData
{
    title: string;
    dataMethod: string;
    metadataMethod: string;
    width: number;
    model: any;
    metadata: ClassMetadata;
    readOnly: boolean;
}

@Component({
    selector: "metadata-dialog-component",
    templateUrl: "./metadata.dialog.tmpl.html",
    imports: [
        CdkScrollable,
        CommandBarComponent,
        LayoutAlignDirective,
        LayoutDirective,
        FlexFillDirective,
        ForgeLinearProgressModule,
        FormsModule,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        MetadataPanelComponent,
        ReactiveFormsModule,
    ]
})
export class MetadataDialogComponent
{
    private readonly dialogRef = inject<MatDialogRef<MetadataDialogComponent>>(MatDialogRef);
    private dialogData = inject<MetadataDialogData>(MAT_DIALOG_DATA);
    private readonly $apiService = inject(ApiService);
    private $metadataService = inject(MetadataService);

    readonly commands: ReadonlyArray<Command>;

    loading: boolean = true;
    data: MetadataDialogData;

    @ViewChild("form") form: NgForm;

    constructor()
    {
        const $apiService = this.$apiService;

        this.dialogRef.disableClose = true;
        this.data = this.dialogData;

        this.commands = [
            new LabelCommand({
                label: "Done",
                action: () => this.cancel(),
                getEnabled: () => true,
                getVisible: () => this.data.readOnly,
            }),
            new LabelCommand({
                label: "Cancel",
                action: () => this.cancel(),
                getEnabled: () => true,
                getVisible: () => !this.data.readOnly,
            }),
            new LabelCommand({
                label: "OK",
                action: () => this.confirm(),
                getEnabled: () => true,
                getVisible: () => !this.data.readOnly,
            }),
        ];

        if (!this.data.model || !this.data.metadata)
        {
            if (Utilities.IsNullOrUndefinedOrEmpty(this.data.dataMethod))
            {
                console.log("Error: dataMethod not provided!");
                this.cancel();
                return;
            }
            if (Utilities.IsNullOrUndefinedOrEmpty(this.data.metadataMethod))
            {
                console.log("Error: metadataMethod not provided!");
                this.cancel();
                return;
            }
            const self = this;
            this.$apiService.sendAuth(this.data.dataMethod)
                .then(data =>
                {
                    self.data.model = data;
                    self.$apiService.sendAuth(this.data.metadataMethod)
                        .then((metadata: ClassMetadata) =>
                        {
                            self.data.metadata = metadata;
                            self.loading = false;
                        });
                });
        }
        else
        {
            this.loading = false;
        }
    }

    confirm(): void
    {
        if (!this.form.invalid)
        {
            this.dialogRef.close(this.data.model);
        }
        else
        {
            this.$metadataService.touchForm(this.form.controls);
        }
    }

    cancel(): void
    {
        this.dialogRef.close();
    }
}
